import { Menu, X } from 'lucide-react'
import { useState } from 'react'
import { Logo } from './header/Logo'
import { Navigation, type NavigationItem } from './header/Navigation'
import { LoginButton } from './header/LoginButton'
import { SignupButton } from './header/SignupButton'

export interface NavbarProps {
  navigationItems?: NavigationItem[]
  showLogin?: boolean
  showSignup?: boolean
  className?: string
}

export function Navbar({ 
  navigationItems,
  showLogin = true,
  showSignup = true,
  className = ''
}: NavbarProps = {}) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  const defaultNavigation: NavigationItem[] = [
    { name: 'Features', path: '/features' },
    { name: 'Pricing', path: '/pricing' },
    { name: 'Demo', path: '/demo' },
    { name: 'About', path: '/about' }
  ]

  const navigation = navigationItems || defaultNavigation

  const handleMobileMenuClose = () => {
    setMobileMenuOpen(false)
  }

  return (
    <nav className={`sticky top-0 z-50 bg-white/80 backdrop-blur border-b border-neutral-200 ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Logo />

          {/* Desktop navigation */}
          <div className="hidden md:flex items-center gap-6">
            <Navigation items={navigation} />
            {showLogin && <LoginButton />}
            {showSignup && <SignupButton />}
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 rounded-lg text-neutral-700 hover:bg-neutral-100"
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileMenuOpen && (
        <div className="md:hidden border-t border-neutral-200 bg-white">
          <div className="px-4 pt-2 pb-4 space-y-1">
            <Navigation 
              items={navigation} 
              mobile 
              onItemClick={handleMobileMenuClose}
            />
            {showLogin && (
              <LoginButton 
                mobile 
                onClick={handleMobileMenuClose}
              />
            )}
            {showSignup && (
              <SignupButton 
                mobile 
                onClick={handleMobileMenuClose}
              />
            )}
          </div>
        </div>
      )}
    </nav>
  )
}
